import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Message } from 'semantic-ui-react';

import { TitledCard } from 'Components/';
import { Main } from 'Containers/';
import MPWWebApi from 'API/MPWApi';
import { toastSuccess, toastError } from 'Common/ToastHelper';

export default class PowerSchoolBulkImport extends Component {
  static propTypes = {
    stepComplete: PropTypes.func.isRequired,
    prevStep: PropTypes.func.isRequired,
    HasManualBeenRunNotes: PropTypes.string,
    isComplete: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
  };

  startImport = async () => {
    const { stepComplete } = this.props;
    this.setState({ loading: true });

    try {
      await MPWWebApi.getGeneric(`sisintegration/powerschool/import`);
      stepComplete();
      toastSuccess('Import Started');
    } catch (error) {
      toastError(error.response.Title || error.response.Message);
    }

    this.setState({ loading: false });
  };

  getMainProps = () => {
    const { prevStep } = this.props;

    return {
      toolbox: {
        backButtonProps: { shown: true, callback: prevStep },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Main {...this.getMainProps()}>
        <TitledCard title={'Manual Import'}>
          {!this.props.isComplete && (
            <React.Fragment>
              <p>
                Running manual import will start importing your students by
                mapping their data according to the mapping configuration you
                chose.
              </p>
              {this.props.HasManualBeenRunNotes && (
                <Message info>
                  <Message.Header>
                    {this.props.HasManualBeenRunNotes}
                  </Message.Header>
                </Message>
              )}
              <Button
                primary
                loading={this.state.loading}
                onClick={this.startImport}
              >
                Start Import
              </Button>
            </React.Fragment>
          )}
          {this.props.isComplete && (
            <p>
              The import has started, you will receive a notification when it is
              finished. You can leave this page without interrupting the
              progress.
            </p>
          )}
        </TitledCard>
      </Main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/components/PowerSchoolBulkImport.js